import React, {FC} from 'react';

import {FrontEvent} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {DropdownProps} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {OnFutureTimeValueSelectOptions} from '../../../../srcCommon/models/futureTimeDropdownTypes';
import {CustomSnoozeModel} from '../../../models/api/customSnoozeModel';
import {FutureTimeValuesEnum} from '../../../models/api/futureTimeValueModel';
import {ReminderPresets} from '../../../models/api/preferencesModel';
import {ReminderModel} from '../../../models/api/reminderModel';
import {FutureTimeDropdownPresetsList} from './futureTimeDropdownPresetsList';
import {FutureTimeDropdownSimple} from './futureTimeDropdownSimple';

export interface FutureTimeDropdownPresetsProps extends DropdownProps {
  values: ReadonlyArray<FutureTimeValuesEnum>;
  reminderPresets: ReminderPresets | null;
  customSnoozes: ReadonlyArray<CustomSnoozeModel> | null;
  customSnoozePreset?: ReminderModel;
  onValueSelect: (options: OnFutureTimeValueSelectOptions) => void;
  showCustom: (event: FrontEvent) => void;
}

export const FutureTimeDropdownPresets: FC<FutureTimeDropdownPresetsProps> = (props) => {
  // If there are no Reminder Presets or Custom Snoozes, display the Send Later Dropdown.
  if (!props.reminderPresets && !props.customSnoozes) {
    return (
      <FutureTimeDropdownSimple
        customSnoozePreset={props.customSnoozePreset}
        values={props.values}
        onValueSelect={props.onValueSelect}
        showCustom={props.showCustom}
        onRequestClose={props.onRequestClose}
        width={props.width}
        height={props.height}
        maxWidth={props.maxWidth}
        maxHeight={props.maxHeight}
        interactionId={props.interactionId}
        hasBackground={props.hasBackground}
        isExclusive={props.isExclusive}
        anchor={props.anchor}
        placement={props.placement}
      />
    );
  }

  return (
    <FutureTimeDropdownPresetsList
      values={props.values}
      reminderPresets={props.reminderPresets}
      customSnoozePreset={props.customSnoozePreset}
      onValueSelect={props.onValueSelect}
      showCustom={props.showCustom}
      onRequestClose={props.onRequestClose}
      width={props.width}
      height={props.height}
      maxWidth={props.maxWidth}
      maxHeight={props.maxHeight}
      interactionId={props.interactionId}
      hasBackground={props.hasBackground}
      isExclusive={props.isExclusive}
      anchor={props.anchor}
      placement={props.placement}
      customSnoozes={props.customSnoozes}
    />
  );
};
